"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _main = _interopRequireDefault(require("../main"));
// 直接import router会报错，所以引用Vue实例

var codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};
var securityKey = 'DfEqd%AvjY1!pFEx*4g$E%hL77b#ecjR';
var access_token;

// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  if (access_token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['Cookie'] = 'ds_token=' + access_token;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
  }
  if (!!_jsCookie.default.get('roleUser') && !!_store.default.getters.userInfo.roleUser) {
    if (_jsCookie.default.get('roleUser') !== _store.default.getters.userInfo.roleUser) {
      alertFun();
      return Promise.reject(new Error(_store.default.state.app.language === 'zh' ? '当前登录已过期，请重新登录。' : 'The current login has expired. Please log in again.'));
    }
  }
  return config;
}, function (error) {
  // do something with request error
  // console.log(error) // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  var errortext = codeMessage[response.status] || response.statusText;
  console.error({
    message: "\u8BF7\u6C42\u9519\u8BEF ".concat(response.status, ": ").concat(response.url),
    type: 'error',
    duration: 5 * 1000
  });
  var error = new Error(errortext);
  error.name = '' + response.status;
  error.response = response;
  return Promise.reject(error);
}, function (error) {
  console.dir('error', error);
  console.dir('error response', error.response);
  return Promise.reject(error.response.data);
});
var alertFun = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
    var confirmElements, languageFlag;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          confirmElements = window.document.getElementsByClassName('el-message-box__wrapper');
          if (!(confirmElements.length === 0 || confirmElements.length > 0 && confirmElements[0].style.display === 'none' || confirmElements.length > 0 && confirmElements[0].style.display !== 'none' && confirmElements[0].firstElementChild.className.indexOf('expiredTag') === -1)) {
            _context2.next = 5;
            break;
          }
          languageFlag = _store.default.state.app.language === 'zh';
          _context2.next = 5;
          return _elementUi.MessageBox.alert(languageFlag ? '当前登录已过期，请重新登录。' : 'The current login has expired. Please log in again.', languageFlag ? '提示' : 'Hint', {
            customClass: 'expiredTag',
            distinguishCancelAndClose: true,
            confirmButtonText: languageFlag ? '确定' : 'Confirm'
          }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
            return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _store.default.dispatch('user/logout');
                case 2:
                  _main.default.$router.push('/login');
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))).catch(function () {});
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function alertFun() {
    return _ref.apply(this, arguments);
  };
}();
var _default = exports.default = service;